import { render, staticRenderFns } from "./d2-source.vue?vue&type=template&id=6bf982d2&scoped=true"
import script from "./d2-source.vue?vue&type=script&lang=js"
export * from "./d2-source.vue?vue&type=script&lang=js"
import style0 from "./d2-source.vue?vue&type=style&index=0&id=6bf982d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf982d2",
  null
  
)

/* custom blocks */
import block0 from "./d2-source.vue?vue&type=custom&index=0&blockType=vue-filename-injector"
if (typeof block0 === 'function') block0(component)

export default component.exports